import { render, staticRenderFns } from "./entriesEmpty.vue?vue&type=template&id=3b12011a"
import script from "./entriesEmpty.vue?vue&type=script&lang=js"
export * from "./entriesEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports